
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogo-mayorista",
      function () {
        return require("private-next-pages/catalogo-mayorista/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogo-mayorista"])
      });
    }
  